module.exports = __webpack_public_path__ + "static/kvm_4.7bcb991f.jpg";